import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import SignInInputWithLabel from './SignInInputWithLabel';
import AuthFormButton from './AuthFormButton';
import { SET_MODAL } from '../../redux/Modal';
import { NEW_PASSWORD_REQUEST } from '../../redux/authReducer';
import AuthFormContainer from './AuthFormContainer';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const NewPasswordFrom = ({ newPasswordRequest, newPasswordFormError, emailSent, setModal, t, }) => {
  const [email, setEmail] = useState('');
  const classes = useStyles();
  const handleSubmit = (event) => {
    event.preventDefault();
    newPasswordRequest(email);
    setEmail('');
  };
  if (emailSent) {
    setModal({ componentName: 'NewPasswordModal', isCloseButtonShown: false, });
  }
  return (
    <AuthFormContainer>
      <form className={classes.newPassForm} onSubmit={handleSubmit}>
        <SignInInputWithLabel
          labelText={t('email')}
          filedName="email"
          onChange={(value) => setEmail(value)}
          value={email}
          error={newPasswordFormError}
          errorMessage={t('invalid_email')}
        />
        <AuthFormButton text={t('sent')} />
      </form>
    </AuthFormContainer>
  );
};

NewPasswordFrom.propTypes = {
  t: PropTypes.func.isRequired,
  newPasswordRequest: PropTypes.func.isRequired,
  setModal: PropTypes.func.isRequired,
  newPasswordFormError: PropTypes.bool,
  emailSent: PropTypes.bool,
};

NewPasswordFrom.defaultProps = {
  newPasswordFormError: false,
  emailSent: false,
};

const useStyles = createUseStyles({
  newPassForm: {
    fontSize: '13px',
    fontWeight: '700',
    color: '#b0acb7',
    marginTop: '2.5em',
    textAlign: 'left',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    newPasswordRequest: (email) => dispatch(NEW_PASSWORD_REQUEST(email)),
    setModal: (params) => dispatch(SET_MODAL(params)),
  };
};

const mapStateToProps = (state) => {
  return {
    newPasswordFormError: state.authReducer.newPasswordFormError,
    emailSent: state.authReducer.emailSent,
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('signIn')
)(NewPasswordFrom);

